/* cinematic-scroll.js — unified, coordinated, scroll-linked cinematic motion
   for BOTH desktop and mobile. Built on GSAP ScrollTrigger (already loaded
   globally in theme.liquid). Additive & safe: if GSAP is missing or the user
   prefers reduced motion, it does nothing and the page is untouched.

   Ownership (to avoid double-animating):
   - Entrance/opacity reveals stay with gsap-animations.js (desktop) and
     mobile-experience.js (phones).
   - THIS module owns scroll-SCRUBBED motion only: hero parallax choreography,
     media depth parallax, and subtle section drift. Different properties /
     elements, so the two layers complement instead of fight. */
(function () {
  'use strict';
  try {
    if (!window.gsap || !window.ScrollTrigger) {
      if (window.console) console.warn('[cinematic-scroll] GSAP/ScrollTrigger missing — skipped.');
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    gsap.registerPlugin(ST);

    // Shared cinematic easing token so desktop + mobile feel identical.
    var LINK = 'none'; // scrubbed motion must be linear so it tracks the finger/wheel

    function build(cfg) {
      var cleanups = [];

      /* ---- 1) HERO scroll choreography (the "camera pull") ---- */
      var hero = document.querySelector('.hero-3d');
      if (hero) {
        var inner = hero.querySelector('.hero-3d__content-inner');
        var media = hero.querySelector('.hero-3d__media');
        var backdrop = hero.querySelector('.hero-3d__backdrop');
        var st = {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: cfg.scrub
        };
        var tl = gsap.timeline({ scrollTrigger: st });
        if (inner) tl.to(inner, { yPercent: -cfg.heroText, opacity: 0.08, ease: LINK }, 0);
        if (media) tl.to(media, { yPercent: cfg.heroMedia, scale: cfg.heroScale, ease: LINK }, 0);
        if (backdrop) tl.to(backdrop, { yPercent: cfg.heroBack, ease: LINK }, 0);
        cleanups.push(tl);
      }

      /* ---- 2) MEDIA depth parallax (editorial imagery drifts inside frame) ---- */
      var mediaSel = [
        '.luxury-story__media img',
        '.luxury-signature__media img',
        '.luxury-lookbook__tile img'
      ].join(',');
      gsap.utils.toArray(mediaSel).forEach(function (img) {
        var frame = img.parentElement;
        if (frame) frame.style.overflow = 'hidden';
        gsap.set(img, { scale: cfg.imgScale, transformOrigin: '50% 50%', willChange: 'transform' });
        var tw = gsap.fromTo(img,
          { yPercent: -cfg.imgShift },
          {
            yPercent: cfg.imgShift, ease: LINK,
            scrollTrigger: { trigger: frame || img, start: 'top bottom', end: 'bottom top', scrub: cfg.scrub }
          });
        cleanups.push(tw);
      });

      /* ---- 3) Subtle section drift for depth between blocks ---- */
      gsap.utils.toArray('.lh-section').forEach(function (sec) {
        var shell = sec.querySelector('.lh-shell');
        if (!shell) return;
        var tw = gsap.fromTo(shell,
          { y: cfg.shell },
          {
            y: -cfg.shell, ease: LINK,
            scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: cfg.scrub }
          });
        cleanups.push(tw);
      });

      /* ---- 4) Banner overlay text gentle rise (cinematic caption) ---- */
      var banner = document.querySelector('.luxury-banner');
      if (banner) {
        var content = banner.querySelector('.luxury-banner__content');
        if (content) {
          var tw2 = gsap.fromTo(content,
            { yPercent: cfg.caption },
            {
              yPercent: -cfg.caption, ease: LINK,
              scrollTrigger: { trigger: banner, start: 'top bottom', end: 'bottom top', scrub: cfg.scrub }
            });
          cleanups.push(tw2);
        }
      }

      // matchMedia cleanup: revert everything this context created.
      return function () {
        cleanups.forEach(function (c) {
          if (c && c.scrollTrigger) c.scrollTrigger.kill();
          if (c && c.kill) c.kill();
        });
      };
    }

    var mm = gsap.matchMedia();
    // Desktop: fuller, slower cinematic depth.
    mm.add('(min-width: 750px)', function () {
      return build({ scrub: 1, heroText: 24, heroMedia: 14, heroScale: 0.9, heroBack: 28, imgScale: 1.2, imgShift: 9, shell: 26, caption: 8 });
    });
    // Phones: lighter amounts + snappier scrub so it stays smooth on touch.
    mm.add('(max-width: 749px)', function () {
      return build({ scrub: 0.6, heroText: 16, heroMedia: 8, heroScale: 0.94, heroBack: 16, imgScale: 1.12, imgShift: 5, shell: 12, caption: 5 });
    });

    // Recalculate after fonts/images settle so triggers line up perfectly.
    window.addEventListener('load', function () { ST.refresh(); });
  } catch (e) {
    if (window.console) console.warn('[cinematic-scroll] disabled:', e);
  }
})();
